import React from 'react';
import {
  CreateButton, Datagrid, DateField, Filter, FunctionField, List, SelectInput, TextField, TextInput, TopToolbar,
} from 'react-admin';
import FeatureIntro from '../../components/FeatureIntro';
import Permission from '../../components/Permission';
import { PERMISSIONS } from '../../constants';
import { getChainId } from '../../lib';
import ManualLinkButton from '../../manual/components/ManualLinkButton';
import BolaoStatusChip from './BolaoStatusChip';

const BolaoFilters = (props: any) => (
  <Filter {...props}>
    <TextInput source="q" label="Buscar nome" alwaysOn />
    <SelectInput
      source="status"
      label="Status"
      alwaysOn
      choices={[
        { id: 'draft', name: 'Rascunho' },
        { id: 'active', name: 'Ativo' },
        { id: 'closed', name: 'Fechado' },
        { id: 'result_pending', name: 'Aguardando processar' },
        { id: 'processed', name: 'Processado' },
        { id: 'inactive', name: 'Inativo' },
      ]}
    />
  </Filter>
);

const ListActions = () => (
  <TopToolbar>
    {Permission({
      permission: PERMISSIONS.GIFT,
      children: (
        <FeatureIntro
          id="manual-bolao"
          title="Manual do Bolão"
          description="Acesse o manual completo do Bolão para entender como cadastrar jogos, vincular os brindes do Clube e processar os ganhadores."
        >
          <ManualLinkButton slug="bolao" label="Manual do Bolão" />
        </FeatureIntro>
      ),
    })}
    <CreateButton />
  </TopToolbar>
);

const BolaoList: React.FC = (props: any) => {
  const chainId = getChainId();

  return (
    <List
      {...props}
      resource="boloes"
      filters={<BolaoFilters />}
      actions={<ListActions />}
      sort={{ field: 'scheduledAt', order: 'DESC' }}
      filter={{ chainId }}
      hasCreate
      title="Bolões da Copa"
    >
      <Datagrid rowClick="show" bulkActionButtons={false}>
        <FunctionField label="Status" render={(r: any) => <BolaoStatusChip status={r.status} />} />
        <TextField source="name" label="Nome" />
        <FunctionField label="Partida" render={(r: any) => `${r.homeTeamName} × ${r.awayTeamName}`} />
        <DateField source="scheduledAt" label="Início do jogo" showTime />
        <DateField source="guessDeadlineAt" label="Deadline palpite" showTime />
      </Datagrid>
    </List>
  );
};

export default BolaoList;
